/*
sai krishna 01/19/2023 2698197526 added  batch tabs for open and closed
Ashraf 01/25/2023 2698197526 Added tab rejected
*/
import Tabs from './Tabs';
import { Card } from '@material-ui/core';
import { useSelector } from 'react-redux';
import LandingPage from '../../../LandingPage';
import React, { useContext, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router';
import { ThemeContext } from '../../../../../src/themes/ThemeProvider';

function index() {
  const history = useHistory();
  const location = useLocation();
  const [value, setValue] = React.useState(0);
  const tabLabels = ['Open', 'Approved', 'Rejected'];
  const { reusableInputStyles } = useContext(ThemeContext);
  const { roleData } = useSelector(({ role }) => role);
  const newBusinessAccess = roleData?.window?.['New Business Maintenance']?.['NBM'];
  const classes = reusableInputStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setValue(location?.state?.tabValue || 0);

    if (history.location.pathname === '/new-business/approved') {
      setValue(1);
    }
    if (history.location.pathname === '/new-business/rejected') {
      setValue(2);
    }
  }, []);

  useEffect(() => {
    setValue(location?.state?.tabValue || 0);
  }, [location?.state?.tabValue]);

  return (
    <LandingPage
      title={'Operations'}
      showTabs={true}
      tabValue={value}
      handleTabChange={handleChange}
      allAntTabs={tabLabels}
    >
      <div className="global-field-dash-board">
        <Card className={`${classes.cardBordernoneStyles} rounded`}>
          <Tabs value={value} setValue={setValue} newBusinessAccess={newBusinessAccess} />
        </Card>
      </div>
    </LandingPage>
  );
}

export default index;
